import { render } from "./ContactsList.vue?vue&type=template&id=34eb0db8&scoped=true"
import script from "./ContactsList.vue?vue&type=script&lang=js"
export * from "./ContactsList.vue?vue&type=script&lang=js"

import "./ContactsList.vue?vue&type=style&index=0&id=34eb0db8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34eb0db8"]])

export default __exports__